/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ClaudeConversationItemResult
 */
export interface ClaudeConversationItemResult {
  /**
   *
   * @type {string}
   * @memberof ClaudeConversationItemResult
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof ClaudeConversationItemResult
   */
  html: string;
  /**
   *
   * @type {string}
   * @memberof ClaudeConversationItemResult
   */
  apolloEmail: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ClaudeConversationItemResult
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the ClaudeConversationItemResult interface.
 */
export function instanceOfClaudeConversationItemResult(
  value: object,
): value is ClaudeConversationItemResult {
  if (!("role" in value) || value["role"] === undefined) return false;
  if (!("html" in value) || value["html"] === undefined) return false;
  if (!("apolloEmail" in value) || value["apolloEmail"] === undefined)
    return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function ClaudeConversationItemResultFromJSON(
  json: any,
): ClaudeConversationItemResult {
  return ClaudeConversationItemResultFromJSONTyped(json, false);
}

export function ClaudeConversationItemResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClaudeConversationItemResult {
  if (json == null) {
    return json;
  }
  return {
    role: json["role"],
    html: json["html"],
    apolloEmail: json["apolloEmail"],
    createdAt: json["createdAt"],
  };
}

export function ClaudeConversationItemResultToJSON(
  json: any,
): ClaudeConversationItemResult {
  return ClaudeConversationItemResultToJSONTyped(json, false);
}

export function ClaudeConversationItemResultToJSONTyped(
  value?: ClaudeConversationItemResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    role: value["role"],
    html: value["html"],
    apolloEmail: value["apolloEmail"],
    createdAt: value["createdAt"],
  };
}
